import { useMutation } from '@tanstack/react-query'

import { useAlerts } from '../../theme/hooks/useAlerts'
import { resetAanvraag } from '../services/resetAanvraag'

export { useResetAanvraag }

const useResetAanvraag = () => {
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: resetAanvraag,
    onSuccess: () => {
      successAlert('Aanvraag succesvol gereset')
    },
  })
}
